<template>
  <div>
    <a-card :title="$t('cardTitle.updateYourProfile')" :class="`style3 text-center profile ${isDesktop ? 'desktop' : 'mobile'}`">
      <a-form :form="form" :label-col="isDesktop ? { span: 6 } : {}" :wrapper-col="isDesktop ? { span: 18 } : {}" :layout="isDesktop ? 'horizontal' : 'vertical'" @submit="handleSubmit">
        <a-row>
          <a-col :md="{ span: 6, offset: 1 }">
            <a-form-item :label="''">
              <div style="text-align: left; margin-left: 25%;">
                <a-avatar :src="photoUrl" shape="square" :size="120" icon="user" />
                <div style="width: 120px; height: 120px; position: absolute; top: 0;" class="avatar-input-wrapper">
                  <input
                    id="avatar-file-input"
                    @change="handleImageChange"
                    style="width: 0; height: 0; position: absolute; opacity: 0;"
                    type="file"
                    :multiple="false"
                    :accept="'image/jpeg, image/png'"
                    ref="imagePicker"
                  />
                  <a-button shape="circle" @click="selectAvatar" for="avatar-file-input" icon="camera" />
                  <a-button shape="circle" @click="removeAvatar" icon="delete" />
                </div>
              </div>
            </a-form-item>
          </a-col>
          <a-col :md="{ span: 16, offset: 1 }" class="account-info-box">
            <a-form-item :label="'Church Name'" v-if="user.user.churchName" class="text-left">
              <span>{{ user.user.churchName }}</span>
              <a-button @click="isEditChurchVisible = true" type="link" icon="edit" style="margin-left: 2rem;"></a-button>
            </a-form-item>
            <a-form-item :label="'Shipping Address'" class="text-left">
              <span>{{ shippingAddress }}</span>
              <a-button @click="isShippingVisible = true" type="link" icon="edit" style="margin-left: 2rem;"></a-button>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :md="{ span: 11, offset: 1 }">
            <a-form-item :label="$t('label.firstName')">
              <a-input v-decorator="['firstname']" />
            </a-form-item>
          </a-col>
          <a-col :md="{ span: 11, offset: 1 }">
            <a-form-item :label="$t('label.lastName')">
              <a-input v-decorator="['lastname']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :md="{ span: 11, offset: 1 }">
            <a-form-item :label="$t('label.email')">
              <a-input v-decorator="['email', { rules: [{ type: 'email', required: true, message: $t('placeholder.pleaseInputYourEmail') }] }]" />
            </a-form-item>
          </a-col>
          <a-col :md="{ span: 11, offset: 1 }">
            <a-form-item :label="$t('label.newPassword')">
              <a-input v-decorator="['password', { rules: [{ required: false, message: $t('placeholder.pleaseInputYourPassword') }] }]" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row type="flex" justify="end">
          <a-col>
            <a-form-item>
              <a-button type="primary" class="tf-btn tf-btn-primary" style="width: 200px;" html-type="submit" :loading="isLoading">{{ $t('button.updateProfile') }}</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-card>

    <a-modal title="Email Verification" :centered="true" :visible="isVerificationFormVisible" :closable="false" class="email-verification">
      <div>
        <p class="code-label">Verification Code</p>
        <a-input v-model="token" />

        <p class="text-center code-description">
          Please input the verification code that we emailed you. If you don't receive an email in 30 seconds you can <a @click="sendToken" class="text-underline">Resend</a>. Thank you!
        </p>
      </div>
      <template slot="footer">
        <a-button key="back" @click="cancelVerify">Cancel</a-button>
        <a-button key="submit" type="primary" class="tf-btn-primary" :disabled="!token" @click="verifyEmail">Verify</a-button>
      </template>
    </a-modal>

    <a-modal title="Edit Church Name" :centered="true" :visible="isEditChurchVisible" :closable="false" class="edit-church">
      <div>
        <p class="church_name">New Church Name</p>
        <a-input v-model="newChurchName" :default-value="user.user.churchName" />
      </div>
      <template slot="footer">
        <a-button key="back" @click="cancelChurchName">Cancel</a-button>
        <a-button key="submit" type="primary" class="tf-btn-primary" :disabled="!newChurchName" :loading="isChurchUpdating" @click="updateChurchName">Save</a-button>
      </template>
    </a-modal>

    <a-modal :visible="previewVisible" :closable="false" class="editProfile">
      <a-spin v-if="isLoadingCropper" size="large" />
      <cropper
        v-if="previewImage != null"
        ref="cropper"
        class="cropper"
        :src="previewImage"
        @change="cropChange"
        @ready="onCropperReady"
        :stencilProps="{
          aspectRatio: 1,
        }"
      />
      <template slot="footer">
        <a-button key="back" @click="handleCancel">{{ $t('button.back') }}</a-button>
        <a-button key="submit" type="primary" @click="handleOk">{{ $t('button.submit') }}</a-button>
      </template>
    </a-modal>

    <edit-shipping-info v-if="isShippingVisible" @onClose="isShippingVisible = false"></edit-shipping-info>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { isEmpty } from 'lodash';
import { Cropper } from 'vue-advanced-cropper';
import UserService from '@/services/UserService';
import AdminService from '@/services/AdminService';
import Uploader from '@/services/UploadService';
import EditShippingInfo from '@/components/EditShippingInfo';

export default {
  data: () => ({
    isLoading: false,
    isVerificationFormVisible: false,
    isEditChurchVisible: false,
    isEditChurchWebsite: false,
    isEditChurchPhone: false,
    isChurchUpdating: false,
    isShippingVisible: false,
    isEmailVerified: false,
    token: '',
    previewVisible: false,
    isLoadingCropper: false,
    previewImage: '',
    imageCropped: '',
    photoUrl: '',
    newChurchName: '',
  }),
  components: {
    Cropper,
    EditShippingInfo,
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, {
      name: 'account_form',
    });
  },
  computed: {
    ...mapState(['settings', 'user']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
    shippingAddress() {
      const shippingInfo = this.user.user.shippingInfo;
      if (isEmpty(shippingInfo)) {
        return;
      }

      return ['address1', 'address2', 'city', 'state', 'zipcode']
        .map(attr => shippingInfo[attr])
        .filter(v => !!v)
        .join(' ');
    },
  },
  async mounted() {
    this.$nextTick(() => {
      const { email, firstname, lastname, photo_url } = this.user.user;
      this.photoUrl = photo_url;

      this.form.setFieldsValue({
        email,
        firstname,
        lastname,
      });
    });
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();

      this.form.validateFields(async (err, values) => {
        if (err) {
          return;
        }

        if (this.user.user.email !== values.email) {
          await this.sendToken();
          this.isVerificationFormVisible = true;
          return;
        }

        await this.saveChanges();
      });
    },
    async sendToken() {
      const email = this.form.getFieldValue('email');
      await UserService.doSendNewEmailToken({
        id: this.user.user.userId,
        email: email,
      });
    },
    cancelVerify() {
      this.form.setFieldsValue({
        email: this.user.user.email,
      });
      this.isVerificationFormVisible = false;
      this.token = '';
    },
    async verifyEmail() {
      const user = this.user.user;

      try {
        const resp = await UserService.doVerifyNewEmail({
          id: user.userId,
          token: this.token,
        });

        if (resp.temporary_email_verified) {
          this.isVerificationFormVisible = false;

          await this.saveChanges();
        }
      } catch (e) {
        console.log(e);
      }
    },
    cancelChurchName() {
      this.isEditChurchVisible = false;
      this.isEditChurchWebsite = false;
      this.isEditChurchPhone = false;
      this.newChurchName = '';
    },
    async updateChurchName() {
      const accountId = this.user.user.accountId;
      this.isChurchUpdating = true;
      try {
        await AdminService.account.update(accountId, { name: this.newChurchName });
        this.$store.dispatch('updateUser', {
          user: {
            ...this.user.user,
            churchName: this.newChurchName,
          },
        });
        this.newChurchName = '';

        this.isEditChurchVisible = false;
      } catch (e) {
        console.log(e);
      } finally {
        this.isChurchUpdating = false;
      }
    },

    async saveChanges() {
      const values = this.form.getFieldsValue();
      try {
        this.isLoading = true;
        const updated = {
          email: this.user.user.email,
          new_email: values.email,
          firstname: values.firstname,
          lastname: values.lastname,
          password: values.password,
        };
        const photoUrl = this.user.user.photo_url;
        if (this.photoUrl && photoUrl !== this.photoUrl) {
          const { Location } = await new Uploader().uploadImage({ file: this.photoUrl, contentType: 'image/png', fileName: 'avatar' });
          updated['photo_url'] = Location;
        }
        await UserService.doUpdateUser(updated);
        this.$store.dispatch('updateUser', {
          user: {
            ...this.user.user,
            email: updated.new_email,
            firstname: updated.firstname,
            lastname: updated.lastname,
            photo_url: updated.photo_url,
          },
        });
        this.$notification['success']({
          message: 'Update profile',
          description: 'You have successfully updated profile!',
        });
      } catch (ex) {
        console.log(ex);
      } finally {
        this.isLoading = false;
      }
    },
    handleImageChange(event) {
      const image = event.target.files[0];
      if (!image) {
        return;
      }

      this.previewImage = URL.createObjectURL(image);
      this.previewVisible = true;
      this.$refs.imagePicker.value = null;
    },
    selectAvatar() {
      this.$refs.imagePicker.click();
    },
    removeAvatar() {
      this.photoUrl = null;
      this.previewVisible = false;
      this.form.setFieldsValue({
        photo_url: null,
      });
    },
    cropChange({ canvas }) {
      if (canvas) {
        this.imageCropped = canvas.toDataURL('image/jpeg');
      }
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handleOk() {
      this.photoUrl = this.imageCropped;
      this.previewVisible = false;
    },
    onCropperReady() {
      this.isLoadingCropper = false;
    },
  },
};
</script>
<style lang="scss">
.account-info-box {
  .ant-form-item {
    margin-bottom: 0;
    .ant-form-item-label {
      line-height: 1.2rem;
      label {
        margin-top: 10px;
      }
    }
  }
}
.email-verification {
  .ant-modal-title {
    text-align: center;
  }

  .code-label {
    font-family: 'Source Sans Pro';
    font-size: 16px;
    color: #212b36;
    line-height: 20px;
    font-weight: 600;
  }
  .code-description {
    font-family: 'Source Sans Pro';
    font-size: 12px;
    color: #212b36;
    line-height: 20px;
    font-weight: 400;
    white-space: break-spaces;

    .text-underline {
      text-decoration: underline !important;
    }
  }
}
.avatar-input-wrapper {
  opacity: 0;
  display: flex;
  justify-content: space-evenly;
  align-items: center;

  &:hover {
    background: rgba($color: #000000, $alpha: 0.3);
    opacity: 1 !important;
  }
}
</style>
